import CognitiveResultView, { ResultQuizCognitiveType } from "./cognitive-result-view";
import { useCognitiveResultModel } from "./../useCognitiveResultModel";
import {
  QuestionApiServiceImpl,
  QuizApiServiceImpl,
  UserApiService,
} from "app/services";

type CognitiveResultProps = {
  processResultCognitive: (result: ResultQuizCognitiveType[]) => void;
};

const CognitiveResultListing = ({processResultCognitive}: CognitiveResultProps) => {
  const userService = new UserApiService();
  const questionService = new QuestionApiServiceImpl();
  const quizService = new QuizApiServiceImpl();
  const model = useCognitiveResultModel({
    userService,
    questionService,
    quizService,
    processResultCognitive,
  });

  return <CognitiveResultView {...model} />;
};

export default CognitiveResultListing;
